import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { CdekLocation } from './CdekLocation'
import { OrderDeliveryMethodCdekDto } from './OrderDeliveryMethodCdekDto'
import { OrderDeliveryMethodPickupDto } from './OrderDeliveryMethodPickupDto'
import { OrderDeliveryMethodManualDto } from './OrderDeliveryMethodManualDto'
import { DeliveryMethodKind } from './Enums'
/**
* Class OrderDeliveryDto
*  Информация о доставке<br>
*/
export class OrderDeliveryDto extends ActiveModel {

  /**
  * kind
  * словарь значений публикуется под именем `Domain.Entities.Channels.DeliveryMethodKind`  *   * Вид способа доставки.  *   * - `Cdek` СДЭК  *   * Интеграция СДЭК (не более одной записи на канал).  * - `Pickup` Самовывоз  *   * Самовывоз со склада (не более одной записи на канал).  * - `Manual` Без интеграции  *   * Способ без интеграции API (может быть несколько на канал).  *   */
  @ActiveField(DeliveryMethodKind.CDEK)
  kind: DeliveryMethodKind = DeliveryMethodKind.CDEK


  /**
  * deliveryMethodId
  * Ссылка на запись каталога канала (если есть).  */
  @ActiveField(null)
  deliveryMethodId: null | number = null


/**
  * methodName
  * Снимок названия способа на момент оформления.
  */
  @ActiveField(null)
  methodName: null | string = null


  /**
  * from
  * Адрес отправления (CDEK / склад). Для Manual может не заполняться смыслом CDEK.<br>  */
  @ActiveField({
    factory: [CdekLocation, () => CdekLocation.create()]
  })
  from: CdekLocation = CdekLocation.create()


/**
  * methodInfo
  * Подробности конкретного метода доставки<br>  */
  @ActiveField({
  setter(model: OrderDeliveryDto, prop: string, value: OrderDeliveryMethodCdekDto | OrderDeliveryMethodPickupDto | OrderDeliveryMethodManualDto, receiver?: OrderDeliveryDto ) {
      let concreteValue = value
      switch (value.kind) {
          case 'Cdek': {
            concreteValue = OrderDeliveryMethodCdekDto.create(value)
            break;
          }
          case 'Pickup': {
            concreteValue = OrderDeliveryMethodPickupDto.create(value)
            break;
          }
          case 'Manual': {
            concreteValue = OrderDeliveryMethodManualDto.create(value)
            break;
          }
      }

      return Reflect.set(
        model,
        prop,
        concreteValue,
        receiver
      )
    }
  })
  methodInfo: OrderDeliveryMethodCdekDto | OrderDeliveryMethodPickupDto | OrderDeliveryMethodManualDto | null | undefined = undefined


  /**
  * calculatedPrice
  * Рассчитанная / зафиксированная стоимость доставки.  */
  @ActiveField(0)
  calculatedPrice: number = 0


/**
  * trackingUrl
  * Ссылка для отслеживания (опционально).
  */
  @ActiveField(null)
  trackingUrl: null | string = null


  /**
  * refundDelivery
  * Если true, то стоимость доставки была возвращена<br>  */
  @ActiveField(null)
  refundDelivery: null | boolean = null
}
